import React, {useEffect} from "react";
import {Navigate} from "react-router-dom";

import {logout} from "../../utils/utils";


const LogoutPage = () => {
  useEffect(() => {
    logout(true);
  }, []);
  return (
    <Navigate to="/login" replace={true}/>
  );
};

export default LogoutPage;